<template>
  <div class="gallery-backdrop">
    <div class="gallery-container">
      <CloseSVG @click="closeGallery()" class="close-cross" />
      <div class="tabs-container" :class="{centered: hasUpload}">
        <span
          v-if="hasUpload"
          class="tab"
          @click="selectedTab = 99"
          :class="{ active: selectedTab == 99 }"
          >{{ toLocal('generic.upload') }}</span>
        <span
          class="tab"
          @click="selectedTab = 0"
          :class="{ active: selectedTab == 0 }"
          >Giphy</span
        >
        <span
          class="tab"
          @click="selectedTab = 1"
          :class="{ active: selectedTab == 1 }"
          >Pixabay</span
        >
      </div>
      <div class="gallery-main-container">
        <GalleryTab v-if="selectedTab != 99" :key="selectedTab" :tab="tabs[selectedTab]" @returnGif="returnPickedGif"/>
        <div class="upload-container item-content-container" v-if="selectedTab == 99 && selectedItemData"  
        :class="{'dragging-over': isDraggingOver && !selectedItemData['data'], 'editing': !selectedItemData['data']}"
        @dragstart.prevent="uploadDragStart"
        @dragover.prevent="uploadDragOver"
        @dragleave.prevent="isDraggingOver=false"
        @dragdrop.prevent
              >
            <div
              class="item-content-container"
              :class="{'dragging-over': isDraggingOver && !selectedItemData['data']}"
              @dragstart.prevent="uploadDragStart"
              @dragover.prevent="uploadDragOver"
              @dragleave.prevent="isDraggingOver=false"
              @dragdrop.prevent
              v-if="!selectedItemData['data']"
            >
              <div class="label">
                {{toLocal('training_edit.drag_media')}}
              </div>
            </div>
                <div class="upload-zone" @drop.prevent="onTrainingMediaChange($event)" @dragover.prevent="uploadDragOverImage" v-if="isDraggingOver && !selectedItemData['data']" @dragleave.prevent="isDraggingOver=false" >
                    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44C0 68.3005 19.6995 88 44 88Z" fill="#C5C5C5"/>
                      <path d="M86.3109 55.7101C82.2709 70.3601 70.8609 81.9401 56.3109 86.2101C55.8009 85.7701 55.3309 85.3101 54.9109 84.7801C54.2809 84.2901 53.7109 83.7201 53.2209 83.0901C52.5909 82.6001 52.0209 82.0301 51.5309 81.4001C50.8909 80.9101 50.3309 80.3301 49.8309 79.7001C49.2009 79.2101 48.6309 78.6401 48.1409 78.0101C47.5109 77.5201 46.9409 76.9501 46.4509 76.3201C45.8209 75.8301 45.2509 75.2601 44.7509 74.6301C44.1209 74.1401 43.5509 73.5701 43.0609 72.9401C42.4309 72.4501 41.8609 71.8801 41.3609 71.2501C40.7309 70.7601 40.1609 70.1901 39.6709 69.5501C39.0409 69.0601 38.4709 68.4901 37.9809 67.8601C37.3509 67.3601 36.7809 66.7901 36.2909 66.1601C35.6609 65.6701 35.0909 65.1001 34.5909 64.4701C33.9609 63.9801 33.4009 63.4101 32.9009 62.7801C32.2709 62.2901 31.7009 61.7101 31.2009 61.0901C30.5709 60.6001 30.0009 60.0201 29.5109 59.3901C28.8809 58.9001 28.3109 58.3301 27.8209 57.7001C27.1909 57.2001 26.6209 56.6301 26.1309 56.0001C25.5009 55.5101 24.9309 54.9401 24.4409 54.3101C23.8109 53.8201 23.2409 53.2501 22.7509 52.6201C20.4409 50.8201 18.9609 48.0101 18.9609 44.8601C18.9609 39.5801 23.1409 35.2501 28.3709 35.0201C28.5409 35.0201 28.7009 35.0101 28.8709 35.0101H28.9109C29.0009 35.0101 29.1009 35.0101 29.1909 35.0101C29.3209 35.0101 29.4609 35.0301 29.6009 35.0401C29.6009 35.0401 29.6609 35.0401 29.7009 35.0401C30.3109 28.6301 35.5509 23.6401 41.9709 23.3401C42.1609 23.3401 42.3509 23.3301 42.5409 23.3301H42.5909C46.0809 23.3601 49.2809 25.0101 51.6009 27.7801C51.7209 27.8801 51.8409 27.9901 51.9609 28.1001C52.8509 29.2401 53.6009 30.5501 54.1609 32.0201C54.3209 31.9701 54.4809 31.9201 54.6509 31.8601C55.4809 31.6001 56.4109 31.2901 57.1709 31.2801H57.1909C57.2909 31.2801 57.3909 31.2801 57.4809 31.2801C60.9909 31.4001 64.1009 33.0601 66.1709 35.6001C66.2809 35.6901 66.3909 35.7801 66.4909 35.8701C66.9909 36.3001 67.4509 36.7801 67.8609 37.2901C68.4809 37.8001 69.0509 38.3701 69.5609 38.9901C70.1809 39.4901 70.7509 40.0601 71.2509 40.6801C71.8709 41.1801 72.4309 41.7501 72.9409 42.3701C73.5609 42.8701 74.1309 43.4401 74.6309 44.0601C75.2509 44.5601 75.8209 45.1301 76.3209 45.7501C76.9409 46.2601 77.5109 46.8301 78.0209 47.4401C78.6409 47.9501 79.2009 48.5201 79.7109 49.1301C80.3309 49.6401 80.9009 50.2101 81.4109 50.8301C82.0309 51.3301 82.5909 51.9001 83.1009 52.5201C83.7209 53.0201 84.2909 53.5901 84.7909 54.2101C85.3409 54.6501 85.8309 55.1501 86.2909 55.6901L86.3109 55.7101Z" fill="#ACACAC"/>
                      <path d="M57.2105 31.2898C56.4405 31.2898 55.5005 31.5998 54.6605 31.8698C54.4905 31.9298 54.3305 31.9798 54.1705 32.0298C52.1305 26.7398 47.6405 23.3398 42.6005 23.3398C35.9005 23.3398 30.3305 28.4498 29.7105 35.0598C29.4305 35.0398 29.1705 35.0198 28.9205 35.0198C23.4805 35.0198 19.0605 39.4398 19.0605 44.8798C19.0605 50.3198 23.4805 54.7398 28.9205 54.7398H57.6105V54.7198C63.8906 54.4998 68.9305 49.3398 68.9305 43.0198C68.9305 36.6998 63.6705 31.2998 57.2005 31.2998L57.2105 31.2898Z" fill="white"/>
                      <path d="M54.23 47.6296C54.18 47.5196 54.11 47.4096 54.03 47.3096L46.85 37.7696C46.76 37.6396 45.77 36.3096 44.12 36.3096C43.4 36.3096 42.34 36.5696 41.39 37.7996L34.42 47.4896C34.29 47.6696 34.19 47.8696 34.13 48.0796C33.75 49.3696 34.2 50.2396 34.5 50.6396C35.25 51.6396 36.4 51.7196 36.74 51.7196H39.32V62.6996C39.32 63.7796 40.21 64.6596 41.29 64.6596H47.35C48.43 64.6596 49.25 63.7796 49.25 62.6996V51.7196H51.7C52.1 51.7196 53.47 51.6296 54.21 50.4496C54.5 49.9796 54.89 48.9896 54.23 47.6296Z" fill="#ACACAC"/>
                      <path d="M36.01 48.6299L42.94 38.9899C44.18 37.3899 45.28 38.9399 45.28 38.9399L52.46 48.4899C53.1 49.8099 51.69 49.7699 51.69 49.7699H47.28V61.9599C47.28 62.3699 46.95 62.7099 46.53 62.7099H42.01C41.6 62.7099 41.26 62.3799 41.26 61.9599V49.7699H36.73C36.73 49.7699 35.65 49.7899 35.99 48.6299H36.01Z" fill="white"/>
                    </svg>
                </div>
              <!-- <NewImageEditor 
              class="upload-row"
              :class="{editing: selectedItemData['image']}"
              v-if="selectedItemData['image']"
              :readOnly="false"
              :height="300"
              :width="400"
              :item="selectedItemData"
              :forFolders="true"
              type="cover"
              :isEditing="true"
              :src="`${this.$store.state.api_uploads_link}/${selectedItemData['image']}`"
              @saveMetadata="saveImageMetadata"
          
              /> -->
              <div class="image-uploaded-container" v-if="selectedItemData['data'] && selectedItemData['data']['image']">
                <div class="image-container">
                  <div class="remove-btn" @click="removeImage">X</div>
                  <img :src="selectedItemData['data']['type'] && selectedItemData['data']['type'] == 'gif' ? selectedItemData['data']['image'] : `${this.$store.state.api_uploads_link}/${selectedItemData['data']['image']}`"/>
                </div>
              </div>
              <div class="upload-row" v-if="!isDraggingOver && !selectedItemData['data']">
                  <input 
                      :ref="`trainingItemFile`" 
                      accept=".png,.jpg,.jpeg,.gif,.bmp,.heic,.heif,.zip"
                      type="file"
                      style="display: none;"
                      @change="onTrainingMediaChange"
                  >
                  <div class="media" @click="$refs[`trainingItemFile`].click()">
                      <img 
                          src="@/assets/images/icons/training-item-upload.svg"
                      >
                      <!-- <div class="description">
                          {{toLocal('training_edit.upload_options.computer')}}
                      </div> -->
                  </div>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Giphy from "../galleryElements/Giphy.vue";
import Pixabay from "../galleryElements/Pixabay.vue";
import GalleryTab from "../galleryElements/GalleryTab.vue";

import CloseSVG from "@/assets/images/icons/training-edit/gallery/close.svg?inline";
import ItemUploadOptions from "../trainings/training_components/trainingItem/ItemUploadOptions.vue";
import NewImageEditor from '@/components/layout/trainings/training_components/ImageEditor/NewImageEditor.vue';

export default {
  name: "GallerySide",
  components: { 
    Giphy, 
    GalleryTab,
    Pixabay,
    CloseSVG,
    NewImageEditor,
  },
  props: {
    hasUpload:{
      type: Boolean,
      default: false
    },
    selectedItemData:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedTab: 99,
      tabs:[
        {
          id: 1, 
          type: 'giphy',
          policyURL: 'https://support.giphy.com/hc/en-us/articles/360020287091-GIPHY-DMCA-Copyright-Policy',
          tags: [
            {label: 'generic.gif', value: 'gifs'},
            {label: 'generic.sticker', value: 'stickers'},
          ],
          queryParams: {
            "tag": 'tag',
            "site": 'giphy',
            "type": 'type',
            "limit": '50',
            "offset": '1',
          },
          APIDataLabel: 'data',
          imageURLPath: 'images.fixed_width.url',
          imageOriginalURLPath: 'images.original.url',
        },
        {
          id: 2, 
          type: 'pixabay',
          policyURL: 'https://pixabay.com/service/license-summary/',
          tags: [
            {label: 'tags.nature', value: 'nature'},
            {label: 'tags.background', value: 'backgrounds'},
            {label: 'tags.science', value: 'science'},
            {label: 'tags.fashion', value: 'fashion'},
            {label: 'tags.animals', value: 'animals'},
          ],
          queryParams: {
            "tag": 'tag',
            "site": 'pixabay',
            "type": 'type',
            "limit": '50',
            "page": 1
          },
          APIDataLabel: 'hits',
          imageURLPath: 'webformatURL',
          imageOriginalURLPath: 'largeImageURL',
        },
      ],
      isDraggingOver: false,
    };
  },
  mounted(){
    if(this.selectedItemData){
      this.selectedTab = 99;
    }else{
      this.selectedTab = 0;
    }
  },
  methods: {
    removeImage(){
      this.selectedItemData['data'] = null;
      this.$emit('removeGroupImg');
    },
    saveImageMetadata(e){
      console.log(e);
    },
    uploadDragStart(e){
      this.isDraggingOver=true;
    },
    uploadDragOver(e){
      this.isDraggingOver=true;
    },
    uploadDragOverImage(e){
      console.log(e)
    },
    returnPickedGif(gif) {
      this.$emit("returnPickedGif", gif);
    },
    closeGallery() {
      this.$emit("closeGallery");
    },
    onTrainingMediaChange(e){
      this.$emit('changeGroupImg', e);
    }
  },
};
</script>

<style lang="scss" scoped>
.remove-btn{
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: white;
  padding: 4px 12px;
  cursor: pointer;
  border-radius: 50%;
  transition: 0.25s;
  &:hover{
    background-color: #EDF2FE;
  }
}
.image-container{
  position: relative;
  max-width: 90%;
  max-height: 90%;
  img{
    max-width: 100%;
    max-height: 500px;
  }
}
.image-uploaded-container{
  user-select: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-container{
  width: 80%;
  height: 80%;
  background-color: #EFEFEF;
  border: 1px dashed #7D7D7D;
  border-radius: 8px;
  padding: 20px 18px;
  overflow: hidden;
  transition: 0.25s;
  &.editing{
    padding: 0;
  }
  .upload-zone{
  display: flex;
  width: 100%;
  height: 90%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  }
  .upload-row{
    display: flex;
    width: 100%;
    height: 90%;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    &.editing{
      height: 100%;
    }
    .media{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #FFFFFF;
      padding: 20px 16px;
      border-radius: 8px;
      cursor: pointer;
      transition: 0.25s;
      &:hover{
        transform: scale(1.02);
      }
    }
  }
  .label{
    color: #333333;
    font-weight: 600;
    font-size: clamp(12px, 2vw, 16px);
  }
}
.dragging-over{
  background-color: #EDF2FE;
}
.gallery-backdrop {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  .gallery-container {
    border-radius: 12px 12px 0px 0px;
    width: 75%;
    height: 80%;
    background-color: white;
    position: relative;
    .close-cross {
      position: absolute;
      right: 16px;
      top: 19px;
      transition: 0.25s;
      &:hover {
        g {
          stroke: #333333;
        }
      }
      cursor: pointer;
    }
  }
}
.gallery-container {
  display: flex;
  flex-direction: column;
  .tabs-container {
    width: 100%;
    display: flex;
    border-bottom: 2px solid var(--secondary-color);
    padding: 0px 16px;
    padding-top: 16px;
    height: 8%;
    &.centered{
      justify-content: center;
    }
    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      width: clamp(150px, 12vw, 205px);
      border-radius: 8px 8px 0px 0px;
      cursor: pointer;
      border: 1px solid #b2b2b2;
      background: #fff;
      border-bottom: none;
      transition: 0.25s;
      font-size: clamp(12px, 2vh, 20px);
      &:hover {
        background-color: var(--secondary-color);
        font-weight: 600;
      }
      &.active {
        background-color: var(--secondary-color);
        font-weight: 600;
      }
    }
  }
  .gallery-main-container {
    height: 92%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
